import { buildGatewayHost } from '@/core/utils/buildGatewayHost'
import { applyPlaceholdersToRecord } from '@/core/utils/installation'

import type { BuildConfigurationMapParams } from '../interfaces'

import { computeGcgNames, toGcgPlaceholders } from './computeGcgNames'

export const buildConfigurationMap = ({
  selectedTechnology,
  technologyConfigurations,
  isSecured,
  gatewayPath,
  gatewayWsPort,
  libraryData,
  packageManager,
}: BuildConfigurationMapParams): Record<string, string> => {
  if (!selectedTechnology) return {}

  const configs = technologyConfigurations[selectedTechnology] ?? {}
  const protocol = isSecured ? 'wss' : 'ws'
  const gateway = buildGatewayHost(gatewayPath, gatewayWsPort)
  const names = computeGcgNames({ selectedTechnology, libraryData })

  return applyPlaceholdersToRecord(configs, {
    ...toGcgPlaceholders(names),
    gateway,
    licenceKey: 'YOUR_LICENCE_KEY',
    runtime: libraryData?.runtimeName?.toLowerCase() ?? 'unknown-runtime',
    name: names.graftName,
    packageManager,
    library: libraryData?.name ?? 'unknown-library',
    protocol,
  })
}
